import linkifyHtml from 'linkify-html';

/**
 * Directive for clearing tabindex at additional buttons
 *
 * @param app
 */
export const tabindexClearDirective = (app) => {
  const clear = (el, binding) => {
    el.querySelectorAll('.q-field__focusable-action').forEach((child) => {
      child.setAttribute('tabindex', -1);
    });

    if (binding.value) {
      el.querySelectorAll('.dp__input').forEach((child) => {
        child.setAttribute('tabindex', -1);
      });
    }
  };

  app.directive('tabindex-clear', {
    mounted: clear,
    updated: clear,
  });
};

export const capitalizeWordsDirective = (app) => {
  const capitalizeWords = (el) => {
    const input = el.querySelector('input');
    const v = input?.value;
    const splitStr = v.split(' ');
    if (v?.length) {
      for (let i = 0; i < splitStr.length; i += 1) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      input.value = splitStr.join(' ');
    }
  };

  app.directive('capitalize-words', {
    updated: capitalizeWords,
  });
};

const calcTextWidth = (input, text) => {
  const span = document.createElement('span');
  span.textContent = text;
  span.classList = input.classList;
  span.style = input.style;
  Object.assign(span.style, {
    maxWidth: 'none',
    width: 'auto',
    whiteSpace: 'nowrap',
    position: 'absolute',
    opacity: '0',
    visibility: 'hidden',
  });
  input.after(span);
  const { width } = span.getBoundingClientRect();
  span.remove();
  return width;
};

export const autoGrowDirective = (app) => {
  app.directive('autogrow', (el, binding) => {
    const input = el.querySelector('input');
    if (input) {
      let width = calcTextWidth(input, input.value);
      if (!width) {
        width = typeof binding.value === 'string' || typeof binding.value === 'undefined'
          ? calcTextWidth(input, binding.value || input.placeholder) : binding.value || 10;
      }
      input.style.width = `${width}px`;
    }
  });
};

const findIcon = (element) => {
  let iconIsset = false;

  element.childNodes.forEach((childNode) => {
    if (childNode.nodeName.toLowerCase() === 'img') {
      iconIsset = true;
    }
  });

  return iconIsset;
};

const addIconToLink = (elements, iconPath) => {
  Array.from(elements).forEach((element) => {
    if (findIcon(element)) {
      return;
    }

    const icon = document.createElement('img');
    icon.style.width = '14px';
    icon.style.height = '14px';
    icon.style.marginRight = '5px';
    icon.style.position = 'relative';
    icon.style.top = '3px';
    icon.src = iconPath;

    element.prepend(icon);
  });
};

export const linkify = (app) => {
  app.directive('linkify', (el) => {
    el.innerHTML = linkifyHtml(el.innerHTML, {
      target: '_blank',
      defaultProtocol: 'https',
      validate: {
        url: (value) => /^https:\/\//.test(value),
      },
    });
  });

  app.directive('linkify-icon', (el) => {
    addIconToLink(el.querySelectorAll('.link-icon-phone'), `${process.env.SERVER_URI}/images/icon-phone.svg`);
    addIconToLink(el.querySelectorAll('.link-icon-email'), `${process.env.SERVER_URI}/images/icon-email.svg`);
  });
};
